import React from 'react'
import GradeDisplayPreviewComponent from './gradeDisplayComponent'

const GradeDisplayPreview = (props) => {
  return (
    <GradeDisplayPreviewComponent {...props} />
  )
}

export default GradeDisplayPreview
